"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TabTrigger_exports = {};
__export(TabTrigger_exports, {
  TabTrigger: () => TabTrigger,
  isTabTrigger: () => isTabTrigger,
  useTabTrigger: () => import_useTabTrigger2.useTabTrigger
});
module.exports = __toCommonJS(TabTrigger_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react_slot = require("@radix-ui/react-slot");
var import_react_native = require("react-native");
var import_useTabTrigger = require("./useTabTrigger");
var import_useTabTrigger2 = require("./useTabTrigger");
var TabTriggerSlot = import_react_slot.Slot;
function TabTrigger(param) {
  var { asChild, name, href, resetOnFocus, ...props } = param;
  var { trigger, triggerProps } = (0, import_useTabTrigger.useTabTrigger)({
    name,
    resetOnFocus,
    ...props
  });
  if (asChild) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TabTriggerSlot, {
      style: styles.tabTrigger,
      ...props,
      ...triggerProps,
      href: trigger === null || trigger === void 0 ? void 0 : trigger.resolvedHref,
      children: props.children
    });
  }
  var reactNativeWebProps = {
    href: trigger === null || trigger === void 0 ? void 0 : trigger.resolvedHref
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.Pressable, {
    style: styles.tabTrigger,
    ...reactNativeWebProps,
    ...props,
    ...triggerProps,
    children: props.children
  });
}
function isTabTrigger(child) {
  return child.type === TabTrigger;
}
var styles = import_react_native.StyleSheet.create({
  tabTrigger: {
    flexDirection: "row",
    justifyContent: "space-between"
  }
});
//# sourceMappingURL=TabTrigger.js.map
